import classnames from 'classnames';

import style from './ToggleButton.module.scss';

export interface ToggleButtonProps {
    label: string;
    isSelected: boolean;
    onClick(): void;
}

interface Props extends ToggleButtonProps {}

export function ToggleButton({ label, isSelected, onClick }: Props) {
    return (
        <div
            className={classnames([style.root, isSelected && style.selected])}
            onClick={onClick}
        >
            {label}
        </div>
    );
}
